import { useSyncExternalStore } from "react";
import { getBooks } from "../api/books-api";
let books = [];
let initialization = null;
const listeners = new Set();
const notify = () => {
    listeners.forEach((listener) => listener());
};
const subscribe = (listener) => {
    listeners.add(listener);
    return () => {
        listeners.delete(listener);
    };
};
const getSnapshot = () => books;
export const useBooks = () => useSyncExternalStore(subscribe, getSnapshot);
export const initializeBooks = () => {
    if (!initialization) {
        initialization = getBooks()
            .then((loadedBooks) => {
            books = loadedBooks;
            notify();
        })
            .catch((error) => {
            initialization = null;
            throw error;
        });
    }
    return initialization;
};
export const addBook = (book) => {
    books = [...books.filter((item) => item.id !== book.id), book];
    notify();
};
export const removeBook = (bookId) => {
    books = books.filter((book) => book.id !== bookId);
    notify();
};
export const setBookAvailability = (bookId, available) => {
    books = books.map((book) => book.id === bookId ? Object.assign(Object.assign({}, book), { available }) : book);
    notify();
};
